import { Helmet } from 'react-helmet-async'
import { Link, useNavigate } from 'react-router-dom'

export const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className='container mx-auto flex flex-col items-center justify-center min-h-[60vh] px-6 py-12'>
      <Helmet>
        <title>صفحه یافت نشد - بوک استوری</title>
        <meta name='description' content='صفحه مورد نظر یافت نشد' />
      </Helmet>

      <div className='text-center max-w-md'>
        {/* 404 Icon */}
        <div className='mb-8'>
          <svg
            className='w-32 h-32 mx-auto text-yellow-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
            />
          </svg>
        </div>

        {/* Error Code */}
        <h1 className='text-6xl font-bold text-gray-800 dark:text-gray-200 mb-4'>
          404
        </h1>

        {/* Error Message */}
        <h2 className='text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-4'>
          صفحه یافت نشد
        </h2>

        <p className='text-gray-600 dark:text-gray-400 mb-8 leading-relaxed'>
          متأسفانه صفحه مورد نظر شما وجود ندارد یا ممکن است حذف شده باشد.
          <br />
          لطفاً آدرس صفحه را بررسی کنید یا به صفحه اصلی برگردید.
        </p>

        {/* Action Buttons */}
        <div className='flex flex-col sm:flex-row gap-4 justify-center'>
          <button
            onClick={() => navigate(-1)}
            className='px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium'
          >
            بازگشت به صفحه قبل
          </button>

          <Link
            to='/'
            className='px-6 py-3 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-200 font-medium'
          >
            صفحه اصلی
          </Link>
        </div>

        {/* Popular Links */}
        <div className='mt-12'>
          <p className='text-sm text-gray-500 dark:text-gray-400 mb-4'>
            شاید به دنبال این صفحات می‌گردید:
          </p>
          <div className='flex flex-wrap gap-3 justify-center'>
            <Link
              to='/orders'
              className='text-blue-600 dark:text-blue-400 hover:underline text-sm'
            >
              سفارشات من
            </Link>
            <span className='text-gray-400'>•</span>
            <Link
              to='/product-requests'
              className='text-blue-600 dark:text-blue-400 hover:underline text-sm'
            >
              درخواست کتاب
            </Link>
            <span className='text-gray-400'>•</span>
            <Link
              to='/settings'
              className='text-blue-600 dark:text-blue-400 hover:underline text-sm'
            >
              تنظیمات
            </Link>
            <span className='text-gray-400'>•</span>
            <Link
              to='/about'
              className='text-blue-600 dark:text-blue-400 hover:underline text-sm'
            >
              درباره ما
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
